import type { IconProps } from './types';
import './icons.css';

export default function Unlock({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      width={width || 16}
      height={height || 16}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      className={`icon icon-unlock ${className || ''}`}
      fill="none"
    >
      <path
        fill="currentColor"
        d="M8 1.333a3.333 3.333 0 0 1 3.333 3.333v.68c.045.002.088.004.13.008.264.021.526.069.778.197.377.192.683.498.874.874.129.252.176.515.198.778.02.256.02.568.02.93v3.734c0 .362 0 .674-.02.93a2.039 2.039 0 0 1-.198.777 2.002 2.002 0 0 1-.874.874 2.039 2.039 0 0 1-.778.199c-.256.02-.568.02-.93.02H5.467c-.362 0-.675 0-.93-.02a2.039 2.039 0 0 1-.779-.199 2 2 0 0 1-.873-.873 2.038 2.038 0 0 1-.198-.778c-.021-.256-.02-.568-.02-.93V8.133c0-.362-.001-.674.02-.93a2.04 2.04 0 0 1 .198-.778 2 2 0 0 1 .873-.874c.252-.128.515-.176.778-.197.256-.021.569-.02.931-.02H10v-.668a2 2 0 0 0-3.323-1.5.666.666 0 1 1-.882-1A3.324 3.324 0 0 1 8 1.333ZM5.467 6.666c-.384 0-.633.001-.822.017-.181.015-.249.04-.282.056a.667.667 0 0 0-.29.292c-.017.033-.042.1-.057.28A11.38 11.38 0 0 0 4 8.134v3.734c0 .383 0 .632.016.82.015.18.04.249.056.282a.668.668 0 0 0 .291.291c.033.017.101.042.282.057.189.015.438.016.822.016h5.066c.385 0 .633 0 .822-.016.18-.015.248-.04.28-.057a.666.666 0 0 0 .292-.291c.017-.033.042-.1.057-.281.015-.19.016-.437.016-.822V8.133c0-.384-.001-.632-.016-.821-.015-.181-.04-.249-.057-.281a.667.667 0 0 0-.291-.292c-.033-.016-.1-.041-.281-.056a11.254 11.254 0 0 0-.822-.017H5.467Z"
      />
    </svg>
  );
}
